/* eslint-disable @typescript-eslint/ban-types */

// Utility type for nested entry points that supports nullable

// NullableEntryPoint allows the root to be a JSResourceReference<EntryPointComponent<...> | null>
// This is needed in scenarios where we are intentionally excluding a component from being loaded
// e.g when using the clientSideOnly function to exclude entrypoints from being loaded on the server

export function createEntryPoint(
// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
  return params;
}